import * as React from 'react';
import { 
    TextField,
    FunctionField ,
    DateField,
    TextInput,
    SelectInput,
    EditButton,
    ReferenceArrayInput,
    AutocompleteArrayInput,
} from 'react-admin';
import { priceFormat } from '../../common/UtilFunctions';
import { StatusEnum } from '../../common/enum';
import { ProductTypeEnum } from 'src/common/enum/ProductTypeEnum';
import { PriceRangeInput } from 'src/components/input/PriceRangeInput';
import { Datagrid, IfCanAccess, List } from 'src/enterprise/ra-rbac';
import { EditableDatagrid, RowForm } from "src/enterprise/ra-editable-datagrid";
import Transformer from "src/common/Transformer";
import { Chip } from "@mui/material";

const filterToQuery = (searchText, recordId) => ({
    "search": searchText,
    "id.not": recordId,
});

const listFilters = [
    <TextInput source="search" label="Search" alwaysOn />,
    <SelectInput source='type' choices={ProductTypeEnum}/>,
    <SelectInput source="status" choices={StatusEnum}/>,
    <PriceRangeInput source="price.price" label="Price"/>,
    <ReferenceArrayInput
        source="categories.id.in"
        label="Categories"
        reference="admin/product/categories"
        children={
        <AutocompleteArrayInput
            filterToQuery={(e) => ({"search": e})}
            optionText="name"
            label="Categories"
            size="small"
            sx={{ minWidth: "35vw" }}
        />
        }
    />,
    <ReferenceArrayInput
        source="price.price_calculator.in"
        label="Price Calculators"
        reference="admin/product/price-calculators"
        children={
        <AutocompleteArrayInput
            filterToQuery={(e) => ({"search": e})}
            optionText="name"
            label="Price Calculators"
            size="small"
            sx={{ minWidth: "35vw" }}
        />
        }
    />
];

export const ProductList = (props) => {
    return (
        <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
            <EditableDatagrid editForm={<ProductEditForm />} mutationMode="pessimistic" noDelete rowClick="edit" actions={<></>}>
                <TextField source="id" />
                <TextField source="name"/>
                <TextField source="sku" />
                <FunctionField label="Type" source="type" render={record => ProductTypeEnum.find(x => x.id === record.type)?.name}/>
                <FunctionField label="Price" sortBy='price.price' render={(record)=>priceFormat(record.price?.price, record.price?.currency)}/>
                <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>
                <FunctionField label="Stock Quantity" sortBy='stock.quantity.sum' render={record => record.stock_quantity}/>
                <FunctionField label="Categories" render={
                    (record) => {
                        return (
                            <div style={{ display: "flex", gap: 4 }}>
                            {record.categories.map((category, index) => {
                                return (
                                <Chip
                                key={`${index}-${category.id}`}
                                    label={category?.name}
                                />
                                );
                            })}
                            </div>
                        );
                    }}
                />
                <DateField source="created_at" label="Created At"/>
                <IfCanAccess action="edit">
                    <EditButton />
                </IfCanAccess>
            </EditableDatagrid>
        </List>
    );
};

const ProductEditForm = () => {
    const transform = (data) => {
        Transformer(data, {
            remove: [
                "id",
                "createdAt",
                "createdBy",
                "updatedAt",
                "updatedBy",
                "attributeSet",
                "categoryIds",
                "relatedProductIds",
                "visibility",
                "children",
                "price",
                "galleryFeatured",
                "gallery",
                "stockQuantity",
                "stock",
                "attributes",
                "categories",
                "relatedProducts",
                "parent",
                "description",
                "shortDescription",
                "metaDescription",
                "metaTitle",
                "slug",
                "type",
                "weight"
            ],
            update: {
                method: "PATCH"
            },
        });

        return data;
    };
  
    return (
        <RowForm transform={transform}>
            <TextField source="id" />
            <TextField source="name"/>
            <TextField source="sku" />
            <FunctionField label="Type" source="type" render={record => ProductTypeEnum.find(x => x.id === record.type)?.name}/>
            <FunctionField label="Price" sortBy='price.price' render={(record)=>priceFormat(record.price?.price, record.price?.currency)}/>
            <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>
            <FunctionField label="Stock Quantity" sortBy='stock.quantity.sum' render={record => record.stock_quantity}/>
            <FunctionField label="Categories" render={
                (record) => {
                    return (
                        <div style={{ display: "flex", gap: 4 }}>
                        {record.categories.map((category, index) => {
                            return (
                            <Chip
                            key={`${index}-${category.id}`}
                                label={category?.name}
                            />
                            );
                        })}
                        </div>
                    );
                }}
            />
            <DateField source="created_at" label="Created At"/>
        </RowForm>
    );
  };